import { render, staticRenderFns } from "./EvsDetail.vue?vue&type=template&id=9679cc82&scoped=true"
import script from "./EvsDetail.vue?vue&type=script&lang=ts"
export * from "./EvsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9679cc82",
  null
  
)

export default component.exports